import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Typography,
  Box,
  CircularProgress,
  Paper,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import cluppLogo from "../../Assets/logo-clupp.png";

const CluppForm = ({
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  session,
  userNotFound = false,
  actions,
  isTheFistOne,
}) => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const response = await onLoad({ session, landedAt: Date.now() });
        setState(response);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (isTheFistOne) {
      return loadData();
    }

    if (onLoad && session?.sessionID) loadData();
  }, [onLoad, session.sessionID]);

  const handleSubmit = async () => {
    if (onSubmit) {
      setLoading(true);
      try {
        await onSubmit({ state, setLoading });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#F6FDFF",
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Container>
        <Box textAlign="center">
          <img src={cluppLogo} style={{ maxWidth: "170px" }} alt="Clupp Logo" />
        </Box>
        <Paper
          elevation={1}
          sx={{
            padding: "20px",
            margin: "0px auto 20px auto",
            maxWidth: ["100%", "75%"],
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {userNotFound ? (
            <Typography textAlign="center">
              Lo sentimos, no hemos podido reconocer esta cuenta.
            </Typography>
          ) : (
            <>
              <Box>
                <Box mt={2} display="flex" justifyContent="space-between">
                  {prevPage(state) && (
                    <IconButton href={prevPage(state)}>
                      <ArrowBackIcon />
                    </IconButton>
                  )}
                </Box>
                <Box sx={{ marginTop: "20px", marginBottom: "50px" }}>
                  {loading ? (
                    <Box sx={{ textAlign: "center" }}>
                      <CircularProgress />
                    </Box>
                  ) : error ? (
                    <Typography color="error">
                      {"Ocurrio un error inesperado."}
                    </Typography>
                  ) : (
                    content({ state, setState })
                  )}
                </Box>
              </Box>
              {!loading && (
                <Box sx={{ width: "100%" }}>
                  {actions({
                    state,
                    setState,
                    loading,
                    onSubmit: handleSubmit,
                  })}
                </Box>
              )}
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default CluppForm;
